import { IDetailCellRendererParams } from "ag-grid-enterprise";
import { AgGridReact } from "ag-grid-react";
import { useMemo } from "react";

import Stack from "@mui/material/Stack";
import { gridTheme } from "@src/components/MainApp/SharedProductPicker/gridTheme";
import { createVariantColumns } from "@src/components/MainApp/SharedProductPicker/list/productListColumns";
import { ProductPickerProductVariant } from "@src/store/slices/productPicker/types";

const VARIANT_ROW_HEIGHT = 60;

export const ProductListVariant = ({ data }: IDetailCellRendererParams) => {
  const variants = data?.variants || [];

  const columnDefs = useMemo(() => createVariantColumns(), []);
  const gridHeight = useMemo(() => {
    return variants.length * VARIANT_ROW_HEIGHT;
  }, [variants.length]);

  const handleWheel = (e: React.WheelEvent) => {
    const parentViewport = e.currentTarget.closest(".ag-body-viewport");
    if (parentViewport) {
      parentViewport.scrollTop += e.deltaY;
    }
  };

  return (
    <Stack
      onWheel={handleWheel}
      sx={{
        height: `${gridHeight}px`,
        paddingLeft: "36px",
        "& .ag-root-wrapper": {
          border: "none",
          borderRadius: 0,
        },
        "& .ag-header": {
          display: "none",
        },
      }}
    >
      <AgGridReact<ProductPickerProductVariant>
        rowData={variants}
        columnDefs={columnDefs}
        rowHeight={VARIANT_ROW_HEIGHT}
        theme={gridTheme}
        defaultColDef={{ cellStyle: { display: "flex", alignItems: "center" } }}
        suppressCellFocus={true}
        suppressMovableColumns={true}
        suppressContextMenu={true}
        context={{ parentProduct: data }}
      />
    </Stack>
  );
};
